import styled from 'styled-components';
import { rem } from 'polished';

export const StyledFullAddressListItem = styled.div`
  padding: ${rem(16)};
  flex: 1;
`;
